import React from 'react'
import UsersPage from './user-management/UsersPage'

export function Users() {
    return (
        <div className='row g-5 g-xxl-8'>
            <UsersPage />
        </div>
    )
}